import { useSelector } from 'react-redux';
import { getMainAccountId } from '../../store/account';
import { useFeature } from '@repo/features';
import { getImpersonateId } from '../../store/user';
import { getJWTToken } from '../../utils/jwt';

const wrappedUseFeature = <VariationType = string | null,>(
  featureName: string,
) => {
  const mainAccountId = useSelector(getMainAccountId);
  const impersonationId = useSelector(getImpersonateId);
  const token = getJWTToken();

  const feature = useFeature(featureName, mainAccountId, {
    token: token || null,
    impersonateId: impersonationId || null,
  });

  return {
    isFeatureEnabled: feature.isFeatureEnabled,
    variables: feature.variables,
    variationKey: feature.variationKey as VariationType,
    source: feature.source,
    isLoading: feature.isLoading,
  };
};

export default wrappedUseFeature;
